import BaseApi from './BaseApi'

export default class TelemetryApi extends BaseApi {
    async getSnappedTelemetry (hardwareId, startDate, endDate) {
        const request = new URLSearchParams()

        request.append('HardwareId', hardwareId)
        request.append('StartDate', startDate)

        if (endDate) {
            request.append('EndDate', endDate)
        }

        return this.get('/api/v1.0/telemetry', request)
    }
    async getTelemetry (hardwareId, startDate, endDate, unsnappedTelemetry = null) {
        const request = new URLSearchParams()

        request.append('HardwareId', hardwareId)
        request.append('StartDate', startDate)

        if (endDate) {
            request.append('EndDate', endDate)
        }

        if (unsnappedTelemetry) {
            request.append('UnsnappedTelemetry', unsnappedTelemetry)
        }

        return this.get('/api/v1.0/telemetry', request)
    }
    async getSpeedingData (hardwareId, startDate, endDate) {
        const request = new URLSearchParams()

        request.append('HardwareId', hardwareId)
        request.append('StartDate', startDate)

        if (endDate) {
            request.append('EndDate', endDate)
        }

        return this.get('/api/v1.0/telemetry/timeline/speeding', request)
    }
}
